import React, { useEffect } from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Loader2, Smartphone } from 'lucide-react';
import { ensureLoggedIn } from '../services/liff';

const LoginPage = () => {
  const handleLogin = async () => {
    try {
      const ok = await ensureLoggedIn();
      if (ok) {
        window.location.replace('/mystats');
      }
      // If not ok, ensureLoggedIn already redirected to LINE login
    } catch (error) {
      console.error('Login failed:', error);
      window.location.replace('/error?m=' + encodeURIComponent(String(error)));
    }
  };

  useEffect(() => {
    handleLogin();
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-gradient-to-br from-cyan-100 via-blue-50 to-white font-prompt">
      <div className="w-full max-w-md space-y-6">
        <div className="text-center space-y-4">
          <div className="w-20 h-20 mx-auto bg-blue-500 rounded-2xl flex items-center justify-center shadow-lg">
            <Smartphone className="w-10 h-10 text-white" />
          </div>
          <h1 className="text-2xl font-bold text-gray-900">NK Beyblade X</h1>
          <p className="text-gray-600">เข้าสู่ระบบด้วยบัญชี LINE ของคุณ</p>
        </div>

        <Card className="shadow-xl border-0">
          <CardContent className="p-6 space-y-6">
            <div className="text-center space-y-4">
              <div className="w-16 h-16 mx-auto bg-cyan-100 rounded-full flex items-center justify-center">
                <Loader2 className="w-8 h-8 text-blue-600 animate-spin" />
              </div>
              <div>
                <h3 className="font-semibold text-gray-800">กำลังเริ่มต้น LINE Login...</h3>
                <p className="text-sm text-gray-500 mt-1">กรุณารอสักครู่</p>
              </div>
            </div>
          </CardContent>
        </Card>

        <div className="text-center text-xs text-gray-400 space-y-1">
          <p>ขับเคลื่อนโดย LINE LIFF Platform</p>
          <p>ข้อมูลของคุณจะถูกจัดการอย่างปลอดภัย</p>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;